import { render, staticRenderFns } from "./ConfigMenu.vue?vue&type=template&id=d67491bc"
import script from "./ConfigMenu.vue?vue&type=script&lang=js"
export * from "./ConfigMenu.vue?vue&type=script&lang=js"
import style0 from "./ConfigMenu.vue?vue&type=style&index=0&id=d67491bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports